import { newId } from "../ids.js";
import { isoString, systemClock, type Clock } from "../time.js";
import type { RecurrenceRule, RuleInput } from "./types.js";

/** Convert ergonomic RuleInput into an ICS RRULE string. */
export function toRRuleString(input: RuleInput): string {
  const parts: string[] = [`FREQ=${input.freq.toUpperCase()}`];
  if (input.interval && input.interval > 1) parts.push(`INTERVAL=${input.interval}`);
  if (input.byDay && input.byDay.length) parts.push(`BYDAY=${input.byDay.join(",")}`);
  if (input.byMonthDay) parts.push(`BYMONTHDAY=${input.byMonthDay}`);
  if (input.count) parts.push(`COUNT=${input.count}`);
  if (input.until) parts.push(`UNTIL=${toIcsUtc(input.until)}`);
  return parts.join(";");
}

/** Build a new RecurrenceRule row from input. */
export function buildRecurrenceRule(
  input: RuleInput,
  dtstart: Date,
  now: Clock = systemClock,
): RecurrenceRule {
  const ts = isoString(now());
  return {
    id: newId(),
    rrule: toRRuleString(input),
    dtstart: isoString(dtstart),
    until: input.until ? isoString(input.until) : null,
    tz: input.tz ?? null,
    exdates: [],
    created_at: ts,
    updated_at: ts,
    deleted_at: null,
  };
}

function toIcsUtc(d: Date): string {
  // YYYYMMDDTHHMMSSZ
  const iso = d.toISOString();
  return iso.replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
}
